import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteModalComponent } from '../common-components/delete-modal/delete-modal.component';
import { LogoutComponent } from '../common-components/logout/logout.component';
import { PageNotFoundComponent } from '../common-components/page-not-found/page-not-found.component';
import { PopUpModalComponent } from '../common-components/pop-up-modal/pop-up-modal.component';
import { RouterModule } from '@angular/router';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DaysAgoPipe } from '../common-pipes/days-ago.pipe';
declare const $: any;

// array for import export all modules..
const moduleList = [
  CommonModule,
  RouterModule,
  ReactiveFormsModule,
  FormsModule,
  Ng2SearchPipeModule,
];

@NgModule({
  declarations: [
    DeleteModalComponent,
    LogoutComponent,
    PageNotFoundComponent,
    PopUpModalComponent,
  ],
  imports: [moduleList],
  exports: [moduleList],
  providers: [DaysAgoPipe],
})
export class SharedModule {}
